import {
  faExclamationCircle,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortUp, faSortDown } from "@fortawesome/pro-solid-svg-icons";
import { Field, Formik } from "formik";
import React, { useEffect } from "react";
import { isEmpty } from "lodash";
import { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useDeepEffect } from "../../../abstracts";
import {
  FieldInput,
  FormControlSearch,
  LoaderWrapper,
} from "../../../components";
import {
  getInvestmentType,
  getMasterInvestmentBySearchCriteria,
} from "../../../services";
import { formFields, manageFeeFormNames } from "../../../utils";
import InfiniteScroll from "react-infinite-scroller";
import InvestmentSliderInformation from "./InvestmentSliderInformation";
//   import { FieldDropSide, FieldInput, SearchableList } from "../../../components";
//   import { OPTIONS_DATA_MAPPER, toOptionValuesFromMapper } from "../../../utils";
//   import AddSpecificationInformationContainer from "./AddSpecificationInformationContainer";
//   import SpecificationInformationCard from "./SpecificationInformationCard";
const data = [
  {
    InvestmentName: "The columbia mid-capital fu...",
    CUSIP: "1637137",
    InvestmentType: "Investment type B",
  },
  {
    InvestmentName: "The columbia mid-capital fu...",
    CUSIP: "1637137",
    InvestmentType: "Investment type B",
  },
  {
    InvestmentName: "The columbia mid-capital fu...",
    CUSIP: "1637137",
    InvestmentType: "Investment type B",
  },
  {
    InvestmentName: "The columbia mid-capital fu...",
    CUSIP: "1637137",
    InvestmentType: "Investment type B",
  },
  {
    InvestmentName: "The columbia mid-capital fu...",
    CUSIP: "1637137",
    InvestmentType: "Investment type B",
  },
];

const InvestmentSlider = ({
  saveInvestment,
  setSaveInvestment,
  values,
  fields,
  setFieldValue,
  // investmentInformation,
  // setInvestmentInformation,
  // loading,
  // setLoading,
  investmentType,
  setInvestmentTypes,
  investmentErrorMessage,
  setShowErrorMessage,
  setInvestmentSelected,
  investmentSelected,
}) => {
  const [searchInput, setSearchInput] = useState("");
  // const [request, setRequest] = useState({
  //   search: "",
  //   from: 0,
  //   to: 20,
  //   excludeClosedInvestment: true,
  //   companyId: 0,
  // });

  const [request, setRequest] = useState({
    search: "",
    from: 0,
    to: 20,
    excludeClosedInvestment: true,
    companyId: 0,
  });
  let [investmentInformation, setInvestmentInformation] = useState([]);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [loading, setLoading] = useState(false);
  useDeepEffect(() => {
    setLoading(true);
    getMasterInvestmentBySearchCriteria(request)
      .then((response) => {
        console.log("scrolluy", response?.length < 20);
        if (response?.length < 20) setStopInfiniteScroll(true);
        if (append) {
          setInvestmentInformation((invList) => {
            return [...invList, ...response];
          });
        } else {
          setInvestmentInformation(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, [request]);

  const sorterUp = (sortBy) => (a, b) =>
    a[sortBy]?.toLowerCase().localeCompare(b[sortBy]?.toLowerCase());
  // a[sortBy]?.toLowerCase() > b[sortBy]?.toLowerCase() ? 1 : -1;
  const sorterDown = (sortBy) => (a, b) =>
    b[sortBy]?.toLowerCase().localeCompare(a[sortBy]?.toLowerCase());
  // a[sortBy]?.toLowerCase() < b[sortBy]?.toLowerCase() ? 1 : -1;
  const cardHeader = [
    {
      label: "Investment Name",
      columnName: "name",
      width: "35.3%",
    },
    {
      label: "CUSIP",
      columnName: "cusip",
      width: "26.3%",
    },
    {
      label: "Investment Type",
      columnName: "investmentTypeName",
      width: "35.3%",
    },
  ];

  const handleSearch = (event) => {
    setSearchInput(event.target.value);
  };

  // investmentInformation = investmentInformation.filter(item => {
  //     const name = item.name.toLowerCase();
  //     const cusip = item?.cusip?.toLowerCase();
  //     return name?.includes(searchInput.toLowerCase()) && cusip?.includes(searchInput.toLowerCase());
  // });
  let filteredData;

  filteredData = investmentInformation?.filter((item) => {
    return (
      item.name.toLowerCase().includes(searchInput.toLowerCase()) ||
      item?.cusip?.toLowerCase().includes(searchInput.toLowerCase())
    );
  });
  // setInvestmentInformation(filteredData)

  return (
    <form>
      <p className="ft-20 fw-600 pt-3 mb-2" style={{ marginTop: "-80px" }}>
        Select Investment
      </p>
      <hr />
      <LoaderWrapper isLoading={loading}>
        {investmentErrorMessage && (
          <div style={{ color: "red" }}>
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              size="xs"
              style={{ color: "red" }}
            />
            FE032: Choose any investment to proceed
          </div>
        )}
        <div className="d-flex align-item-center pad-50-right justify-content-between">
          <div className="d-flex">
            <div className="d-flex ml-1">
              {/* <Field
                size="md"
                isRequired
                label="Search"
                placeholder="Search investment name,CUSIP"
                name={fields.investmentName}
                type="text"
                autoComplete="off"
                value={values[fields.investmentName]}
                onChange={(e) => handleSearch(e)}
                component={FieldInput}
              /> */}

              <label
                className="fw-600 ft-14"
                style={{ whiteSpace: "nowrap", color: "#919191" }}
              >
                Search
              </label>
              <InputGroup>
                <InputGroup.Prepend>
                  <div
                    className="search-icon-postion"
                    style={{ marginLeft: "-35px", marginTop: "37px" }}
                  >
                    <i class="fas fa-search" aria-hidden="true"></i>
                  </div>
                </InputGroup.Prepend>
                <FormControlSearch
                  size="xs"
                  type="search"
                  placeholder="Search investment name,CUSIP"
                  onChange={(e) => handleSearch(e)}
                  style={{
                    borderRadius: "5px",
                    width: "18rem",
                    marginTop: "27px",
                    marginLeft: "-44px",
                    paddingLeft: "30px",
                  }}
                  // onClick={(e) =>
                  //   setFieldValue(fields.specificationName, e.target.value)
                  // }
                />
              </InputGroup>
            </div>
          </div>
        </div>
        <p
          className="ft-14 fw-600 mt-1"
          style={{ color: "#919191", marginLeft: "9px" }}
        >
          {filteredData.length} Records Found
        </p>

        {!isEmpty(filteredData) ? (
          <>
            <div
              className="payroll-columns w-100"
              style={{ display: "flex", marginLeft: "20px" }}
            >
              {cardHeader.map((item, ind) => (
                <div style={{ width: item?.width }}>
                  <div className="fw-600 ft-14 grey d-flex">
                    <div>{item?.label} </div>
                    <div className="d-flex flex-column ml-10">
                      <FontAwesomeIcon
                        icon={faSortUp}
                        onClick={(e) =>
                          setInvestmentInformation(
                            [...investmentInformation].sort(
                              sorterUp(item.columnName)
                            )
                          )
                        }
                      />
                      <div style={{ marginTop: "-8px" }}>
                        <FontAwesomeIcon
                          icon={faSortDown}
                          onClick={(e) =>
                            setInvestmentInformation(
                              [...investmentInformation].sort(
                                sorterDown(item.columnName)
                              )
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div
              style={{
                height: "70vh",
                paddingRight: "1vh",
                overflow: "scroll",
              }}
            >
              <InfiniteScroll
                pageStart={0}
                loadMore={() => {
                  setAppend(true);
                  setRequest((filterData) => {
                    return {
                      ...request,
                      from: investmentInformation.length,
                      to: investmentInformation?.length + 20,
                    };
                  });
                }}
                hasMore={!stopInfiniteScroll}
                initialLoad={false}
                threshold={100}
                useWindow={false}
                loader={
                  investmentInformation.length != 0 && (
                    <div className="loader" key={0}>
                      Loading ...
                    </div>
                  )
                }
              >
                {filteredData.map((item, index) => {
                  return (
                    <div>
                      <InvestmentSliderInformation
                        investmentInfo={item}
                        index={index}
                        values={values}
                        fields={fields}
                        setFieldValue={setFieldValue}
                        saveInvestment={saveInvestment}
                        setSaveInvestment={setSaveInvestment}
                        investmentType={investmentType}
                        setInvestmentTypes={setInvestmentTypes}
                        setInvestmentSelected={setInvestmentSelected}
                        investmentSelected={investmentSelected}
                      />
                    </div>
                  );
                })}
              </InfiniteScroll>
            </div>
          </>
        ) : (
          <div
            className="fw-400 ft-18"
            style={{ textAlign: "center", marginTop: "15%" }}
          >
            {"No records found"}
          </div>
        )}
      </LoaderWrapper>
    </form>
  );
};

export default InvestmentSlider;
